import Toggle from './Toggle';
import Map from './Map';

export {
    Map,
    Toggle,
};

export default {
    Map,
    Toggle,
};
